<template>
    <div class="table offer-info">
        <div v-for="round in rounds" v-if="round.ssrRoundSupplierCosts.length>0 || round.costBreakdownFiles.length >0">
            <div>Round {{round.roundNumber}}
                <!--下载本轮次Excel-->
                <el-button type="primary" @click="offerDownload(round.ttSsrRoundId)">{{$t('ssrManage.offerDownload')}}</el-button>
            </div>
            <capacity-table :round-id="round.ttSsrRoundId" :files="round.costBreakdownFiles" type="costBreakdown" :template="round.costBreakdownTemplate" :can-edit="canEdit" :data="round.ssrRoundSupplierCosts"></capacity-table>
        </div>
        <!--底部操作按钮-->
        <el-row type="flex" justify="center" style="padding-top: 15px;">
            <el-button v-if="roundIds.length>1" type="primary" @click="offerDownload(roundIds)">Download All</el-button>
            <el-button v-if="haveCostBreakdownFile" type="primary" @click="downloadFile()">Download All Attachments</el-button>
        </el-row>
    </div>
</template>
<script>
    import router from '../../../router';
    import {apiService} from "@/api/ssr-manage/ssr-manage";
    import {Message} from "element-ui";
    import commonMethods from "@/utils/commonMethods";
    import CapacityTable from "@/components/page/ssr-manage/capacity-table";
    import commonFun from "@/utils/commonFun";

    export default {
        name: '',
        extends: commonMethods,
        components: {CapacityTable},
        props: {
            rounds: Array
        },
        computed: {
            haveCostBreakdownFile(){
              return this.rounds.some(round => commonFun.isNotEmpty(round.costBreakdownFiles));
            },
            canEdit() {
                return false;
            },
            roundIds() {
                return this.rounds.filter(round=>round.ssrRoundSupplierCosts.length>0).map(round=>round.ttSsrRoundId)
            }
        },
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
            offerDownload(roundIds){
                apiService.exportCost(roundIds);
            },
            downloadFile(){
              apiService.downloadAllCostBreakdownFile(this.rounds[0].ttSsrId);
            },
        }
    }
</script>
<style scoped>
</style>
